import { useEffect } from 'react'
import { useFormikContext } from 'formik'

import {
  EMAIL_CREATION_FORM_FIELD_NAME_PRINTER,
  getEmailFormAccountsListForBlackListVerification,
} from '../../../Email'
import { useDocFlowSendingContext } from '../../DocFlow.hooks'

function DocFlowSendingEmailFormContainer({ children, modal }) {
  const { emailBlackList, setEmailBlackList } = useDocFlowSendingContext()

  const { values } = useFormikContext()

  const accounts = getEmailFormAccountsListForBlackListVerification(
    values,
    values[EMAIL_CREATION_FORM_FIELD_NAME_PRINTER]
  )

  useEffect(() => {
    if (emailBlackList?.length > 0 && accounts.length > 0) {
      setEmailBlackList(prev => prev.filter(item => accounts.includes(item)))
    }
  }, [accounts])

  return (
    <div>
      {children}
      {modal}
    </div>
  )
}

export default DocFlowSendingEmailFormContainer
